import {HttpExclude, Request} from '@simpli/serialized-request'
import {PageCollection} from '@simpli/resource-collection'
import {NntTag} from '@/model/resource/NntTag'

@HttpExclude()
export class NntTagCollection extends PageCollection<NntTag> {
  resource?: INntTagCollectionResourcesHolder

  constructor() {
    super(NntTag)
  }

  queryAsPage() {
    return this.listNntTag()
  }

  async listNntTag() {
    return await Request.get(`/client/nnt-tag`, {params: this.params})
      .name('listNntTag')
      .as(this)
      .getResponse()
  }

  async listExportNntTag() {
    return await Request.get(`/client/nnt-tag/export`, {params: this.params})
      .name('listExportNntTag')
      .as(this)
      .getResponse()
  }
}

export interface INntTagCollectionResourcesHolder {}
